var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9465 3.9104L14.4818 11.4292C14.363 13.3502 14.3036 14.3107 13.8221 15.0013C13.584 15.3427 13.2776 15.6309 12.9221 15.8474C12.2031 16.2854 11.2408 16.2854 9.31606 16.2854C7.38887 16.2854 6.42526 16.2854 5.70582 15.8466C5.35013 15.6297 5.04353 15.341 4.80554 14.999C4.32419 14.3074 4.26612 13.3455 4.14999 11.4218L3.69653 3.9104",
    stroke: "#FF4444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57153 3.91064H16.0715M12.3633 3.91064L11.8514 2.85444C11.5112 2.15284 11.3411 1.80203 11.0478 1.58325C10.9828 1.53472 10.9139 1.49155 10.8418 1.45417C10.517 1.28564 10.1271 1.28564 9.34741 1.28564C8.54813 1.28564 8.14853 1.28564 7.81829 1.46123C7.74511 1.50015 7.67527 1.54507 7.6095 1.59552C7.31276 1.82317 7.14701 2.18681 6.81549 2.91409L6.36122 3.91064",
    stroke: "#FF4444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44653 12.1606V7.66064",
    stroke: "#FF4444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1965 12.1606V7.66064",
    stroke: "#FF4444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e5fd69cddb673b6a4dd8af5544371b40.svg";
export { ForwardRef as ReactComponent };